module.exports = __webpack_public_path__ + "static/flags/SP-58a9e30f783e86fd5397a6105b8fd281.gif";